import { BasketItem as BasketItemType } from '../../../types/basket';
import { config } from '../../../utils/config';
import ProductDetails from './ProductDetails';
import SoldOut from './SoldOut';
import './style.scss';

type BasketItemProps = {
  item: BasketItemType;
};

const BasketItem = (props: BasketItemProps) => {
  const { item } = props;
  const isSoldOut = false;
  const href = config.origin === 'app' ? `app://pdp/${item.productId}` : item.pdpUrl;

  return (
    <div className="basket-item" data-test-id={`basket-item-${item.id}`}>
      <a
        className="basket-item__image"
        style={{
          backgroundImage: `url('${item.imageUrl}?bg=f4f4f5&height=330&progressive=1&quality=90&width=260')`,
        }}
        href={href}
        onClick={!IS_WEB_COMPONENT ? undefined : () => (window.location.href = href)}
      />
      {isSoldOut ? <SoldOut /> : <ProductDetails item={item} href={href} />}
    </div>
  );
};

export default BasketItem;
